export const UPSC_HERO_PAGES_CMS_API_PATH = 'current-affairs-hero-pages';

const HERO_SESSION_KEYS = [
  'homeHeroSession',
  'todayAnalysisHeroSession',
  'quizHeroSession',
  'calendarHeroSession',
  'monthlyPdfHeroSession',
  'dailyPdfHeroSession',
  'monthlyClassesHeroSession',
  'subjectWiseHeroSession',
  'detailPageHeroSession'
];

const normalizeHeroSession = (session) => {
  if (!session || typeof session !== 'object') {
    return undefined;
  }

  return {
    mainHeading: session.mainHeading,
    description: session.description
  };
};

export const normalizeUpscHeroPagesResponse = (data) => {
  if (!data || typeof data !== 'object') {
    return {};
  }

  return HERO_SESSION_KEYS.reduce((normalized, sessionKey) => {
    const session = normalizeHeroSession(data[sessionKey]);

    if (!session) {
      return normalized;
    }

    return {
      ...normalized,
      [sessionKey]: session
    };
  }, {});
};
